/**
 * Helpers Functions
 */
import moment from 'moment';

const findByKey = (list, key) => {
  return list.find((room) => room.key === key);
};

const getFileType = (file) => {
  let result = null;
  if (file.type.includes('image/') && checkMedia(file.type)) {
    result = 'PHOTO';
  } else if (file.type.includes('video/')) {
    result = 'VIDEO';
  }
  return result;
};

const checkMedia = (path) => {
  let unSupportType = ['heic', 'heif'];
  let fileExt = path.substring(path.lastIndexOf('/') + 1).toLowerCase();
  return !unSupportType.includes(fileExt);
};

const printTimeStampMessageFromDateTime = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss}`, 'YYYYMMDDHHmmss Z').locale('ko').format('a h:mm');
};
const printTimeStampMessageFromDate = (yyyyMMddhhmmss) => {
  return moment(`${yyyyMMddhhmmss}`, 'YYYYMMDDHHmmss Z').locale('ko').format('YYYY-MM-DD HH:mm');
};

const objectMerge = (target, source) => {
  for (let key of Object.keys(source)) {
    if (source[key] instanceof Object) {
      Object.assign(source[key], objectMerge(target[key], source[key]));
    }
  }
  Object.assign(target || {}, source);
  return target;
};

const replaceUrl = (message, color, senderType) => {
  // http, https, mail 및 프로토콜 미지정 URL 링크 태그 추가
  const protocolReg = '(http://|https://|mailto:|)';
  const domainReg = '([0-9a-zA-Z](?:[-_.]?[0-9a-zA-Z])+@)?[a-z0-9]+(?:[\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(?::[0-9]{1,5})?';
  const subPathReg = '(?:/[^\\s]*)?';
  const regURL = new RegExp(protocolReg + '?(' + domainReg + subPathReg + ')', 'gi');
  const result = regURL.exec(message);
  let customColor = color;
  if (result) {
    const target = result[0];
    const mailId = result[3];
    const protocol = result[1] ? result[1] : mailId ? 'mailto:' : 'http://';
    const url = result[2];
    if (senderType !== 'USER') {
      // 상담사(AGENT), 시스템(SYSTEM)
      customColor = '';
    }
    const style = 'color:' + customColor + ';text-decoration:underline';
    message = message.replace(target, '<a href="' + protocol + url + '" target="_blank" style="' + style + '">' + target + '</a>');
  }
  return message;
};

// 모바일 여부 확인
const isMobile = () => {
  return !!(
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  );
};

const formatBytes = (bytes, decimals) => {
  if (bytes === 0) {
    return {
      size: 0,
      sign: 'Bytes'
    };
  }

  const k = 1024;
  const dm = decimals || 2;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return {
    size: parseFloat((bytes / Math.pow(k, i)).toFixed(dm)),
    sign: sizes[i]
  };
};

export default {
  findByKey,
  getFileType,
  printTimeStampMessageFromDateTime,
  printTimeStampMessageFromDate,
  objectMerge,
  replaceUrl,
  isMobile,
  formatBytes
};
